import React from 'react'
import stringSanitizer from "stringSanitizer";
import searchParamsHelper from "@Utils/searchParamsHelper";
import htmlEscape from "htmlEscape";

function searchParamsParser (urlParams) {
  const parsed = {};
  const params = urlParams.split('/');

  const remapProps = {
    q: "location",
    d: "distance",
    gv: "type",
    postcode: "postcode",
    b: "brand",
    page: "page"
  };

  for (let param of params) {
    if (param === 'nos-agences') {
      continue;
    }

    if (param) {
      param = decodeURIComponent(param);
      let matches = param.match(/^(q|d|gv|postcode|b|page)-([^/]+)$/);
      if (matches) {
        const key = remapProps[matches[1]] || matches[1];
        parsed[key] = htmlEscape(matches[2]);
      }
      else if (searchParamsHelper.specialismsList.includes(stringSanitizer(param).toLowerCase())) {
        parsed.specialism = htmlEscape(param);
      }
      else if (!parsed.region && searchParamsHelper.regionList.includes(param)) {
        parsed.region = htmlEscape(param);
      }
      else if (!parsed.department && searchParamsHelper.departmentsList.map(e => stringSanitizer(e).toLowerCase()).includes(stringSanitizer(param).toLowerCase())) {
        parsed.department = htmlEscape(param);
      }
      else {
        // Default case is CITY! (there's nothing that we can catch it by)
        parsed.city = htmlEscape(param);
      }
    }
  }

  return parsed;
}

export default searchParamsParser;
